type ThemeColorPayload = {
  color: {
    primaryActive: string
    botAvatarImage: string
    secondaryActive: string
    primaryHeaderText: string
    secondaryHeaderText: string
    secondaryHighlight: string
    warningHighlight: string
  }
}

export const applyThemeCssVariables = (
  payload: ThemeColorPayload,
  documentRef: Document = document,
): void => {
  const {
    primaryActive,
    botAvatarImage,
    secondaryActive,
    primaryHeaderText,
    secondaryHeaderText,
    secondaryHighlight,
    warningHighlight,
  } = payload.color

  const root = documentRef.documentElement
  root.style.setProperty('--botAvatar', `url(${botAvatarImage})`)
  root.style.setProperty('--mainHighlight', `${primaryActive}`)
  root.style.setProperty('--mainSecondary', `${secondaryActive}`)
  root.style.setProperty('--primaryHeaderText', `${primaryHeaderText}`)
  root.style.setProperty('--secondaryHeaderText', `${secondaryHeaderText}`)
  root.style.setProperty('--secondaryHighlight', `${secondaryHighlight}`)
  root.style.setProperty('--warningHighlight', `${warningHighlight}`)

  const favicon = documentRef.getElementById('favicon') as HTMLLinkElement | null
  if (favicon) {
    favicon.href = botAvatarImage
  }
}
